import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IAPIItemResult,
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "app/services/abstract.service";
import ApplicationsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/authorization/applications/applications.entity";
import { ICreateApplication } from "./interfaces/create-application.interface";
import { IUpdateApplication } from "./interfaces/update-application.interface";
const apiUrl = env.API_AVE_AUTHORIZATION_URL;
const moduleName = "applications";

@Injectable({
  providedIn: "root",
})
export class ApplicationService extends AbstractService<
  ApplicationsAttributes,
  ICreateApplication,
  IUpdateApplication
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<ApplicationsAttributes>
    // companyIds: number[]  // Add your companyIds if necessary
  ): Observable<IPaginationResult<ApplicationsAttributes>> {
    const query = buildQuery<ApplicationsAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      //   companyIds && companyIds.length > 0 ? andAllWhere('company.id' as keyof ApplicationsAttributes, Ops.in(...companyIds)) : noop(),

      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<ApplicationsAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<ApplicationsAttributes[]>> {
    const query = buildQuery<ApplicationsAttributes>(
      select(["code", "name", "subApplications"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<ApplicationsAttributes[]>>(API_URL);
  }

  getApplications(): Observable<ApplicationsAttributes[]> {
    const API_URL: string = apiUrl + `api/${moduleName}`;
    return this.http.get<ApplicationsAttributes[]>(API_URL);
  }
}
